const accessLogo = new URL('../../../assets/kar/vit-karlskrona-kommun.png', import.meta.url).href;

// Load Google Fonts (only in browser)
if (typeof document !== 'undefined') {
  const karlskronaLightFont = document.createElement('link');
  karlskronaLightFont.rel = 'stylesheet';
  karlskronaLightFont.href =
    'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;1,300&family=Rubik:ital,wght@0,300;0,500;0,600;1,300;1,500;1,600&display=swap';
  document.head.appendChild(karlskronaLightFont);
}

export const karlskronaLight = {
  name: 'karlskrona:light',
  extends: 'citizen:light',
  cssPath: 'custom/styles/kar/karlskrona-light.theme',
  vuetify: {
    defaults: {
      AppAccessPage: {
        logoSrc: accessLogo,
        logoAlt: 'Karlskrona kommun',
        backgroundSrc: new URL('../../../assets/kar/header-bg.jpg', import.meta.url).href,
      },
    },
    theme: {
      dark: false,
      colors: {
        'neutral-100': '#FAFAFA',
        'primary-lighten-1': '#4A9BCA',
        'primary-lighten-2': '#8AC4E8',
        'primary-lighten-3': '#C6DFEE',
        secondary: '#AC480D',
        'search-list-hover': '#EBE6E0',
        'secondary-lighten-1': '#C9BFAE',
        'secondary-lighten-2': '#DCD5C9',
        'secondary-lighten-3': '#EEEAE4',
        error: '#99092D',
        'error-lighten-1': '#B8524A',
        'error-lighten-2': '#CE9193',
        'on-error-lighten-2': '#001A1B',
        'error-lighten-3': '#EEEAE4',
        success: '#2F746B',
        'success-lighten-1': '#4A9E90',
        'success-lighten-2': '#8ABFB7',
        'success-lighten-3': '#C6DFE0',
        warning: '#D16F00',
        'warning-lighten-1': '#835400',
        'warning-lighten-2': '#E8B29C',
        'warning-lighten-3': '#FFDDB5',
        surface: '#FAFAFA',
        'on-surface': '#001A1B',
        'surface-variant': '#FAFAFA',
        'on-surface-variant': '#001A1B',
        background: '#E8EAE9',
        foretag: '#CE9193',
        'on-foretag': '#001A1B',
        'background-3': '#EEF8FF',
        'on-background-3': '#001A1B',
        'background-4': '#91A7CA',
        'on-background-4': '#001A1B',
        black: '#001A1B',
        'black-lighten-1': '#333333',
        gray: '#605d62',
        'gray-lighten-1': '#79767a',
        'gray-lighten-2': '#F4F3F2',
        white: '#FFFFFF',
        'white-darken-1': '#EBE6E0',
        red: '#CB6300',
        'badge-disabled': '#A5A5A5',
        'badge-primary': '#2A6960',
        'badge-secondary': '#A99175',
        'badge-tertiary': '#CB6300',
        green: '#419385',
        skog: '#2A6960',
        strand: '#A99175',
        fastigheter: '#CDBFB1',
        'strand-lighten-1': '#CDBFB1',
        'strand-lighten-2': '#EBE6E0',
        disabled: '#A5A5A5',
        loader: '#006B5F',
        'loader-background': '#E0E3E1',
        'text-color-primary': '#1A1C1E',
        'text-color-secondary': '#41474D',
        fullmakter: '#A0D4AA',
        ovriga: '#C3B8CA',
        utbildning: '#BCE4FA',
        omsorg: '#EBDBA3',
        forening: '#EBC79E',
        adshavare: '#91A49D',
        'on-adshavare': '#001A1B',
        anstallningar: '#c4a8c3',
        'on-anstallningar': '#001A1B',
        'sector-privat': '#adc8ac',
        'sector-företag': '#f8ddcd',
        'on-sector-privat': '#001A1B',
        'on-sector-företag': '#001A1B',
        toolbar: '#2A6960',
        'on-toolbar': '#FFFFFF',
        'process-state-active': '#A99175',
        scrollbar: '#2A6960',
        'bulletin-informational': '#E9ECEB',
        'on-bulletin-informational': '#001A1B',
        'bulletin-warning': '#ebdba3',
        'on-bulletin-warning': '#001A1B',
        'bulletin-critical': '#FFB3BA',
        'on-bulletin-critical': '#001A1B',
        'bulletin-success': '#B8E6D5',
        'on-bulletin-success': '#001A1B',
        'my-eservices': '#DE9367',
        'on-my-eservices': '#001A1B',

        // Assignment card and shortcut colors
        'card-assignment': '#D1E550',
        'on-card-assignment': '#001A1B',

        // Page header background colors
        'page-companies-header-bg': '#CE9193',
        'on-page-companies-header-bg': '#001A1B',
        'page-properties-header-bg': '#CDBFB1',
        'on-page-properties-header-bg': '#001A1B',
        'page-authorizations-header-bg': '#A0D4AA',
        'on-page-authorizations-header-bg': '#001A1B',
        'page-children-header-bg': '#91A49D',
        'on-page-children-header-bg': '#001A1B',
        'page-enrollments-header-bg': '#BCE4FA',
        'on-page-enrollments-header-bg': '#001A1B',
        'page-employments-header-bg': '#c4a8c3',
        'on-page-employments-header-bg': '#001A1B',
        'page-eservices-header-bg': '#DE9367',
        'on-page-eservices-header-bg': '#001A1B',
        'page-cases-header-bg': '#DE9367',
        'on-page-cases-header-bg': '#001A1B',
        'arbete-naringsliv': '#CE9193',
        'on-arbete-naringsliv': '#001A1B',
        'boende-miljo': '#CDBFB1',
        'on-boende-miljo': '#001A1B',
        'kommun-politik': '#2563EB',
        'on-kommun-politik': '#FFFFFF',
        'omsorg-stod': '#EBDBA3',
        'on-omsorg-stod': '#001A1B',
        ovrigt: '#C3B8CA',
        'on-ovrigt': '#001A1B',
        'forskola-skola': '#BCE4FA',
        'on-forskola-skola': '#001A1B',
        'kultur-fritid-turism': '#B8A080',
        'on-kultur-fritid-turism': '#001A1B',
        raddningstjansten: '#F28B6D',
        'on-raddningstjansten': '#001A1B',
        'my-cases': '#DE9367',
        'on-my-cases': '#001A1B',
        'my-cases-action': '#DE9367',
        'on-my-cases-action': '#FFFFFF',
        'chip-active': '#DE9367',
        'on-chip-active': '#FFFFFF',
        'page-profile-header-bg': '#CED1D2',
        'on-profile': '#001A1B',
      },
    },
  },
};
